/**
 * Changes an ISO date string to a human-readable standard US date string.
 * Without localizing the date, the date string will be in the format MM/DD/YYYY.
 * @param isoDateString
 * 2024-03-28T00:00:00+00:00 to 03/28/2024
 */
const usFormatDateString = (isoDateString: string): string => {
  const [y, m, d] = isoDateString.split('T')[0].split('-');
  return `${m}/${d}/${y}`;
};

export default usFormatDateString;
